/**
 * @description Click link and download helper function to trigger file downloads
 * Fn removed into separate module in order to facilitate test mocking and avoid 'Not implemented: navigation (except hash changes)' error when clicking link
 *
 * @SADtrace SAD-003-5, SAD-003-6.6
 *
 * @History
 * 04-18-2025 aleksandar dukleski: DLA-1364 added function headers
 * 11-05-2025 aleksandar dukleski: DLA-1428 added history tag to function headers
 *
 * @param {HTMLAnchorElement} tempLink - Temporary anchor element to trigger download
 *
 * @returns {void}
 */
export function clickLinkAndDowload(tempLink: HTMLAnchorElement) {
  tempLink.click();
}
